import { Box, ListItem, Stack, Text, UnorderedList } from '@chakra-ui/react';

interface KeyTakeawaysProps {
  keyTakeaways: string[];
}

export function KeyTakeaways({ keyTakeaways }: KeyTakeawaysProps) {
  return (
    <Box
      bg="gray.100"
      borderRadius="base"
      py={{ base: 'sm', lg: 'lg' }}
      px={{ base: 'm', lg: 'xl' }}
      id="key-takeaways"
    >
      <Text as="h2" size="title2" mb="2xs">
        What to know
      </Text>
      <Stack
        as={UnorderedList}
        styleType="none"
        spacing="3xs"
        sx={{ marginLeft: 0 }}
      >
        {keyTakeaways.map((item, index) => (
          <ListItem
            key={index}
            sx={{
              position: 'relative',
              paddingLeft: { base: 'm', lg: '40px' },
              '&::before': {
                content: '""',
                position: 'absolute',
                left: 0,
                top: '.7em',
                width: { base: '2xs', lg: 'sm' },
                height: '1px',
                backgroundColor: 'blackAlpha.700',
              },
            }}
          >
            <Text size="body2" color="blackAlpha.700">
              {item}
            </Text>
          </ListItem>
        ))}
      </Stack>
    </Box>
  );
}
